import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import api from "../../utils/intercepter/axiosConfig.js";

const ModifierMotPasse = () => {
  const [userId, setUserId] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" ou "error"

  const [isSubmitting, setIsSubmiting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.data.id);
      } catch (error) {
        setMessage("Token invalide.");
        setMessageType("error");
      }
    } else {
      setMessage("Token manquant.");
      setMessageType("error");
    }
  }, []);

    const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

const handleChangePassword = async (e) => {
  e.preventDefault();
  setIsSubmiting(true);

      try {
        const response = await api.post("/auth/modifierMotDePasse", {
          user_id: userId,
          ancienne_mot_passe: oldPassword,
          niveau_mot_passe: newPassword,
          confirm_mot_passe: confirmPassword
        });

        console.log(response.data);

        if (response.data.status) {
          setMessage(response.data.message);
          setMessageType("success");
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          setMessage(response.data.message);
          setMessageType("error");
          if (response.data.nologin) {
            setTimeout(() => logout(), 1000);
          }
        }

      } catch (error) {
        if (error.response) {
          const data = error.response.data;
          setMessage(data.message || "Erreur réseau.");
          setMessageType("error");

          if (data.nologin) {
            setTimeout(() => logout(), 1000);
          }
        } else {
          setMessage("Erreur réseau.");
          setMessageType("error");
        }
      }finally{
          setIsSubmiting(false);
        }
};


  return (
    <div className="container py-5" style={{ paddingBottom: '250px' }}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-4 text-center">
                🔐 Changer mot de passe
              </h5>
              <hr />

              {message && (
                <div className={`mt-3 alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}>
                  {message}
                </div>
              )}

              <form onSubmit={handleChangePassword}>
                <div className="form-group mb-3">
                  <label htmlFor="oldPassword">Ancien mot de passe</label>
                  <input type="password" className="form-control" name="oldPassword" id="oldPassword" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} placeholder="Entrez votre ancien mot de passe" required />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="newPassword">Nouveau mot de passe</label>
                  <input type="password" className="form-control" value={newPassword} name="newPassword" id="newPassword" onChange={(e) => setNewPassword(e.target.value)} placeholder="Entrez votre nouveau mot de passe" required />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="confirmPassword">Confirmation du mot de passe</label>
                  <input type="password" className="form-control" value={confirmPassword} name="confirmPassword" id="confirmPassword" onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirmez votre mot de passe" required />
                </div>

                <div className="d-grid">
                  <button type="submit" className="btn btn-success"  disabled={isSubmitting}>
                    {isSubmitting ? 'En cours...' : "Changer"}
                    </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModifierMotPasse;
